import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-social-twitter',
  templateUrl: './icon-social-twitter.component.html',
  styleUrls: ['./icon-social-twitter.component.scss']
})
export class IconSocialTwitterComponent implements OnInit {
  @Input() size = 40;
  
  constructor() { }

  ngOnInit() {
  }

}
